import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import SobreNos from "@/pages/SobreNos";

export const Route = createFileRoute("/sobre-nos")({
  head: () => seoHead({
    title: "Sobre Nós | Shopping do Bem",
    description: "Conheça a história e a missão do Shopping do Bem.",
    path: "/sobre-nos",
  }),
  component: SobreNos,
});
